import Model from "./base/model";

class RoadMap extends Model {
  resourceName() {
    return "road_maps";
  }

  fields() {
    return {
      company_id: "",
      name: "",
      observation: "",
      collection_date: "", //criar cotação
      delivery_date: "", //criar cotação
      transporter: "", //criar cotação
      dangerous_products: "", //criar cotação
      services: "", //criar cotação
      modals: "", //criar cotação
      obs: "", //criar cotação
      vehicle_type_id: "", //criar cotação
      created_at: "",
      company: { jsonApi: "hasOne", type: "companies"},
      request: { jsonApi: "hasOne", type: "request"},
      simulation_quote: { jsonApi: "hasOne", type: "simulation_quotes"},
      road_map_request: { jsonApi: "hasMany", type: "road_maps_requests"},
      is_less_than_truckload: "",
      is_best_way: "",

      total_volume: "",
      total_value: "",

      value_total: "",
      weight_total: "",
      cubed_total: "",
    };
  }

  async roadMapToSimulationQuotes(data) {
    return this.request(
      "simulation_quotes/road_map",
      "POST",
      {},
      data
    );
  }

}

export default new RoadMap();
